import React, { Fragment } from "react";
import { Modal } from "antd";
import { Button, Icon } from "Components";
import Icons from "Components/Icon/Icons";
import "./modal.scss";

interface CommonModalProps {
    parentClass?: string;
    visible: boolean;
    cancelText: string | null;
    confirmText: string;
    background?: string;
    showConfirmBtn?: boolean;
    confirmBtnDisabled?: boolean;
    iconType: keyof typeof Icons | null;
    modalTitle?: string,
    modalContentTitle?: string,
    modalContentDesc?: string [],
    onClose: () => void;
    onConfirm: () => void;
    children?: React.ReactNode | null
}

const CommonModal: React.FC<CommonModalProps> = ({
    parentClass = '',
    visible,
    cancelText,
    confirmText,
    iconType,
    modalTitle = '',
    background = "white",
    modalContentTitle = '',
    showConfirmBtn = true,
    confirmBtnDisabled = false,
    modalContentDesc,
    onClose,
    onConfirm,
    children = null
}) => {
    return (
        <Modal
            className={`pm-modal ${parentClass}`}
            visible={visible}
            onCancel={onClose}
            footer={null}
            closable={false}
            centered
            width={495}
            bodyStyle={{ padding: 0 }}>
            <div className="pmw-modal-container">
                <div className="pm-modal-header">
                    <div className="pm-modal-header-left">
                        <span className="pm-modal-title">{modalTitle}</span>
                    </div>
                    <button
                        className="pm-modal-close-icon"
                        onClick={onClose}
                        aria-label="Close">
                        <Icon type="campaignModalClose" />
                    </button>
                </div>

                <div className="pm-modal-body">
                    {children != null ? children : <>
                        {iconType && <div className="pm-icon-box" style={{ background }}>
                            <div className="pm-icon-wrapper">
                                <Icon type={iconType || "close"} />
                            </div>
                        </div>}

                        {modalContentTitle && <p className="pm-modal-title-text">{modalContentTitle}</p>}
                        {modalContentDesc?.length && <div>
                            {modalContentDesc?.map((desc, index) => (<Fragment key={index}>
                                <p>{desc}</p>
                                {modalContentDesc?.length - 1 !== index ? <br /> : null}
                            </Fragment>))}
                        </div>}
                    </>}
                </div>

                {<div className="pm-modal-footer">
                    <div className="pm-modal-footer-actions">
                        {cancelText && <Button ghost shape="round" type="default" onClick={onClose} >
                            {cancelText}
                        </Button>}
                        {showConfirmBtn && <Button shape="round" type="primary" disabled={confirmBtnDisabled} className={`${confirmBtnDisabled ? 'cta-disabled' : ''}`}  onClick={onConfirm} >
                            {confirmText}
                            {(parentClass === "phishing-preview-modal" && confirmText === "Next") && <span>
                                <svg
                                    width="16"
                                    height="12"
                                    viewBox="0 0 16 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1 6H14.3333M14.3333 6L9.33333 1M14.3333 6L9.33333 11"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>}
                        </Button>}
                    </div>
                </div>}
            </div>
        </Modal>
    );
};

export default CommonModal;